/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllMediaResponse } from '../../models/get-all-media-response';

export interface MediaServiceGetAllMedia$Params {
  loadDuoCardsMap?: boolean;
}

export function mediaServiceGetAllMedia(http: HttpClient, rootUrl: string, params?: MediaServiceGetAllMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, mediaServiceGetAllMedia.PATH, 'get');
  if (params) {
    rb.query('loadDuoCardsMap', params.loadDuoCardsMap, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllMediaResponse>;
    })
  );
}

mediaServiceGetAllMedia.PATH = '/api/v3/gateway/media/all';
